import * as React from 'react';
import React__default from 'react';
import { Upload as Upload$1 } from '@grandvisionhq/api-client';
import { useRecaptcha } from '@grandvisionhq/forms';
import { useApiConfig, uninitState, statusSuccess, loadingState, successState, failedState, useIntl, statusFailed, statusWarning, statusLoading, statusUninit } from '@grandvisionhq/state';
import classnames from 'classnames';
import { AnimatePresence, motion } from 'framer-motion';
import { useDropzone } from 'react-dropzone';
import { Loader, IconButton } from '@grandvisionhq/common';
import { Text } from '@grandvisionhq/elements';
import { Icon } from '@grandvisionhq/icons';

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.
Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.
THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
var __assign = function() {
    __assign = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}
function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}
function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g;
    return g = { next: verb(0), "throw": verb(1), "return": verb(2) }, typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (_) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}
function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}
function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}
function __spreadArray(to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || from);
}

function isFileRejection(error) {
    return 'file' in error;
}
var isUploadSuccess = function (state) {
    return state.status === 'SUCCESS';
};
var isUploadError = function (state) {
    return state.status === 'ERROR';
};
var isUploadIdle = function (state) { return state.status === 'IDLE'; };
var isUploadIdleAfterFileRemove = function (state) {
    return state.status === 'IDLE' && state.reason === 'FILE_REMOVED';
};
var isUploadLoading = function (state) {
    return state.status === 'LOADING';
};
var uploadStatusSuccess = function (uploadReference) { return ({
    status: 'SUCCESS',
    uploadReference: uploadReference,
}); };
var uploadStatusError = function (error, errorMessageId) { return ({
    status: 'ERROR',
    error: error,
    errorMessageId: errorMessageId,
}); };
var uploadStatusIdle = function (reason) { return (__assign({ status: 'IDLE' }, (reason ? { reason: reason } : {}))); };
var uploadStatusLoading = function () { return ({
    status: 'LOADING',
}); };

var types = /*#__PURE__*/Object.freeze({
    __proto__: null,
    isFileRejection: isFileRejection,
    isUploadSuccess: isUploadSuccess,
    isUploadError: isUploadError,
    isUploadIdle: isUploadIdle,
    isUploadIdleAfterFileRemove: isUploadIdleAfterFileRemove,
    isUploadLoading: isUploadLoading,
    uploadStatusSuccess: uploadStatusSuccess,
    uploadStatusError: uploadStatusError,
    uploadStatusIdle: uploadStatusIdle,
    uploadStatusLoading: uploadStatusLoading
});

var createNoFileError = function () { return new Error('no-file'); };
var LABEL_PREFIX = 'upload.error';
var labelMapping = {
    'file-invalid-type': LABEL_PREFIX + ".fileInvalidType",
    'file-too-large': LABEL_PREFIX + ".fileTooLarge",
    'file-too-small': LABEL_PREFIX + ".fileTooSmall",
    'too-many-files': LABEL_PREFIX + ".tooManyFiles",
    'no-file': LABEL_PREFIX + ".noFile",
    unknown: LABEL_PREFIX + ".unknown",
};
var getUploadErrorLabel = function (currentError) {
    return (isFileRejection(currentError)
        ? labelMapping[currentError.errors[0].code]
        : labelMapping[currentError.message]) || labelMapping.unknown;
};

function useUploadHandler(props) {
    var _a = __read(React__default.useState(function () {
        /**
         * It should check the uploadStatus for all config.handlers and if one of them is in
         * error state the {lastError}, should reflect it.It should also check
         * if config.checkRequired is being set, and if so checks for required property in each handler.
         */
        var _a = props.configs.reduce(function (_a, _b) {
            var isRequired = _a.isRequired, hasError = _a.hasError;
            var required = _b.required, uploadStatus = _b.uploadStatus;
            return ({
                isRequired: isRequired || required,
                hasError: hasError || !!(uploadStatus && isUploadError(uploadStatus)),
            });
        }, { isRequired: false, hasError: false }), isRequired = _a.isRequired, hasError = _a.hasError;
        if (hasError || (props.checkRequired && isRequired)) {
            return createNoFileError();
        }
        return undefined;
    }), 2), lastError = _a[0], setLastError = _a[1];
    var _b = __read(React__default.useState(!!props.checkRequired), 2), setIsSubmitted = _b[1];
    var handlers = React__default.useRef(props.configs.reduce(function (h, _a) {
        var _b;
        var scope = _a.scope;
        return (__assign(__assign({}, h), (_b = {}, _b[scope] = getStatusChangeHandler(scope), _b)));
    }, {}));
    var _c = __read(React__default.useState(props.configs.reduce(function (s, _a) {
        var _b, _c, _d;
        var scope = _a.scope, uploadStatus = _a.uploadStatus, required = _a.required;
        if (uploadStatus && isUploadSuccess(uploadStatus)) {
            return __assign(__assign({}, s), (_b = {}, _b[scope] = uploadStatus, _b));
        }
        if (required && props.checkRequired) {
            return __assign(__assign({}, s), (_c = {}, _c[scope] = uploadStatusError(createNoFileError(), props.sharedErrorElementId), _c));
        }
        return __assign(__assign({}, s), (_d = {}, _d[scope] = uploadStatusIdle(), _d));
    }, {})), 2), state = _c[0], setState = _c[1];
    function getStatusChangeHandler(scope) {
        var _a;
        var isRequired = (_a = props.configs.find(function (_a) {
            var scope = _a.scope;
            return scope === scope;
        })) === null || _a === void 0 ? void 0 : _a.required;
        return function (statusUpdate) {
            setIsSubmitted(function (prevIsSubmitted) {
                setState(function (prevState) {
                    return Object.entries(prevState).reduce(function (m, _a) {
                        var _b, _c;
                        var _d = __read(_a, 2), key = _d[0], status = _d[1];
                        if (key === scope) {
                            var possiblyError = isUploadError(statusUpdate) ? statusUpdate.error : null;
                            /**
                             * If the status update is indicating that a required file will be removed, we'll override
                             * the error to be a "no-file" error.
                             */
                            var error = isUploadIdle(statusUpdate) && isRequired && prevIsSubmitted
                                ? new Error('no-file')
                                : possiblyError;
                            setLastError(error || undefined);
                            return __assign(__assign({}, m), (_b = {}, _b[key] = error ? uploadStatusError(error, props.sharedErrorElementId) : statusUpdate, _b));
                        }
                        /**
                         * To only show the last triggered status update, we're setting all other scopes to IDLE in
                         * case they are in ERROR state. We want to keep all scopes that are SUCCESS as is.
                         */
                        return __assign(__assign({}, m), (_c = {}, _c[key] = isUploadError(status) ? uploadStatusIdle() : status, _c));
                    }, {});
                });
                return prevIsSubmitted;
            });
        };
    }
    function checkMissingFiles() {
        var hasMissingFiles = false;
        var newState = props.configs.reduce(function (m, _a) {
            var _b;
            var scope = _a.scope, required = _a.required;
            if (required && !isUploadSuccess(state[scope])) {
                var error = createNoFileError();
                setLastError(error);
                hasMissingFiles = true;
                return __assign(__assign({}, m), (_b = {}, _b[scope] = uploadStatusError(error), _b));
            }
            return m;
        }, {});
        setState(function (prevState) { return (__assign(__assign({}, prevState), newState)); });
        setIsSubmitted(true);
        return hasMissingFiles;
    }
    return {
        lastError: lastError ? getUploadErrorLabel(lastError) : null,
        checkMissingFiles: checkMissingFiles,
        state: state,
        handlers: handlers.current,
    };
}

var UploadContext = React.createContext({});
var useUpload = function () { return React.useContext(UploadContext); };
var UploadProvider = function (_a) {
    var scopes = _a.scopes, _b = _a.shouldFetchConfigs, shouldFetchConfigs = _b === void 0 ? true : _b, _c = _a.timeout, timeout = _c === void 0 ? 20000 : _c, children = _a.children;
    var timersRef = React.useRef({});
    var mountRef = React.useRef(true);
    var apiUrl = useApiConfig().apiUrl;
    var _d = __read(React.useReducer(function (s, action) {
        var _a;
        if (action.name === 'error') {
            return __assign(__assign({}, s), { error: action.value });
        }
        // updating upload config
        return __assign(__assign({}, s), { configs: __assign(__assign({}, s.configs), (_a = {}, _a[action.name] = action.value, _a)) });
    }, {
        scopes: scopes,
        error: null,
        configs: scopes.reduce(function (m, scope) {
            var _a;
            return (__assign(__assign({}, m), (_a = {}, _a[scope] = uninitState(), _a)));
        }, {}),
    }), 2), state = _d[0], dispatch = _d[1];
    function setError(error) {
        dispatch({ name: 'error', value: error });
    }
    function updateConfig(scope, result) {
        // do not update component state if it has been unmounted
        if (!mountRef.current) {
            return;
        }
        dispatch({ name: scope, value: result });
    }
    React.useEffect(function () {
        var e_1, _a;
        // if the upload radio option does not exist => do not fetch configs
        if (!shouldFetchConfigs) {
            return;
        }
        mountRef.current = true;
        // use one signal to rule them all
        var abortController = new AbortController();
        var signal = abortController.signal;
        var _loop_1 = function (scope) {
            /**
             * If we already have successfully fetched the config for
             * this scope, there's no need to fetch it again.
             */
            var scopeState = state[scope];
            if (scopeState && statusSuccess(scopeState)) {
                return "continue";
            }
            updateConfig(scope, loadingState());
            // setting the timer per scope
            timersRef.current[scope] = window.setTimeout(function () {
                abortController.abort();
            }, timeout);
            // calling API for upload config
            Upload$1.getConfig(apiUrl, { scope: scope }, { signal: signal })
                .then(function (response) {
                clearTimeout(timersRef.current[scope]);
                updateConfig(scope, successState(response));
            })
                .catch(function (error) {
                clearTimeout(timersRef.current[scope]);
                updateConfig(scope, failedState(error));
            });
        };
        try {
            for (var scopes_1 = __values(scopes), scopes_1_1 = scopes_1.next(); !scopes_1_1.done; scopes_1_1 = scopes_1.next()) {
                var scope = scopes_1_1.value;
                _loop_1(scope);
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (scopes_1_1 && !scopes_1_1.done && (_a = scopes_1.return)) _a.call(scopes_1);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return function () {
            // Cancel the running requests when this component is unmounted.
            abortController.abort();
            mountRef.current = false;
        };
    }, [scopes, shouldFetchConfigs]);
    return React.createElement(UploadContext.Provider, { value: __assign(__assign({}, state), { setError: setError }) }, children);
};

var iconSharedProps = {
    initial: { opacity: 0, scale: 0 },
    animate: { opacity: 1, scale: 1 },
    exit: { opacity: 0, scale: 0 },
};
var Upload = function (_a) {
    var _b = _a.variant, variant = _b === void 0 ? 'vertical' : _b, id = _a.id, iconName = _a.iconName, _c = _a.disabled, disabled = _c === void 0 ? false : _c, maximumFileSizeBytes = _a.maximumFileSizeBytes, allowedFileTypes = _a.allowedFileTypes, title = _a.title, uploadStatus = _a.uploadStatus, onFileAccepted = _a.onFileAccepted, onFileRejected = _a.onFileRejected, onDelete = _a.onDelete, onCancel = _a.onCancel, className = _a.className, ariaDescribedBy = _a["aria-describedby"];
    var _d = useIntl(), getFormattedLabel = _d.getFormattedLabel, getLabel = _d.getLabel, hasLabel = _d.hasLabel;
    var descriptionId = "description-" + id;
    var inputId = "file-input-" + id;
    var ariaDescribedByIDList = [descriptionId, ariaDescribedBy].filter(Boolean);
    if (isUploadError(uploadStatus) && uploadStatus.errorMessageId) {
        ariaDescribedByIDList = __spreadArray([uploadStatus.errorMessageId], __read(ariaDescribedByIDList));
    }
    // This should be text like "File upload" to describe what kind of component this is.
    var uploadScreenReaderRole = hasLabel('upload.screenreader.title')
        ? getLabel('upload.screenreader.title')
        : undefined;
    var uploadedFileName = isUploadSuccess(uploadStatus)
        ? uploadStatus.uploadReference.fileName
        : undefined;
    var uploadScreenReaderName = !!uploadedFileName ? title + " " + uploadedFileName : title;
    var onFileDropSuccess = React__default.useCallback(function (files) {
        var file = files[0]; // because uploading multiple files is disabled, we only need to take the first one.
        onFileAccepted(file);
    }, [onFileAccepted]);
    var onFileDropRejected = React__default.useCallback(function (fileRejections) {
        var fileRejection = fileRejections[0];
        onFileRejected(fileRejection);
    }, [onFileRejected]);
    var onDeleteClick = React__default.useCallback(function (event) {
        var _a;
        event.stopPropagation();
        onDelete();
        (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [onDelete]);
    var onCancelClick = React__default.useCallback(function (event) {
        var _a;
        event.stopPropagation();
        onCancel();
        (_a = rootRef.current) === null || _a === void 0 ? void 0 : _a.focus();
    }, [onCancel]);
    var isDisabled = disabled || isUploadLoading(uploadStatus);
    var _e = useDropzone({
        accept: allowedFileTypes,
        maxFiles: 1,
        multiple: false,
        maxSize: maximumFileSizeBytes,
        onDropAccepted: onFileDropSuccess,
        onDropRejected: onFileDropRejected,
        disabled: isDisabled,
    }), getRootProps = _e.getRootProps, getInputProps = _e.getInputProps, isDragActive = _e.isDragActive, isDragAccept = _e.isDragAccept, isDragReject = _e.isDragReject, rootRef = _e.rootRef;
    var iconSize = variant === 'vertical' ? 84 : 48;
    return (React__default.createElement("div", __assign({}, getRootProps(), { tabIndex: isDisabled ? -1 : 0, className: classnames('upload', "upload--" + variant, className, {
            'upload--file-hover': isDragActive,
            'upload--active': isDragActive || isUploadSuccess(uploadStatus),
            'upload--accept': isDragAccept || isUploadSuccess(uploadStatus),
            'upload--reject': isDragReject,
            'upload--error': isUploadError(uploadStatus),
            'upload--loading': isUploadLoading(uploadStatus),
        }), id: id, role: "button", "aria-label": uploadScreenReaderName, "aria-describedby": ariaDescribedByIDList.join(' '), "aria-roledescription": uploadScreenReaderRole }),
        React__default.createElement("div", { className: "upload__inner" },
            React__default.createElement(AnimatePresence, null,
                isUploadSuccess(uploadStatus) && (React__default.createElement(motion.div, __assign({ className: "upload__icon upload__icon--valid" }, iconSharedProps),
                    React__default.createElement(Icon, { name: "checkmark" }))),
                isUploadError(uploadStatus) && (React__default.createElement(motion.div, __assign({ className: "upload__icon upload__icon--invalid" }, iconSharedProps),
                    React__default.createElement(Icon, { name: "alert-circle" }))),
                isUploadLoading(uploadStatus) && (React__default.createElement(motion.div, __assign({ className: "upload__icon upload__icon--loading" }, iconSharedProps),
                    React__default.createElement("div", { className: "sr-only", role: "alert" }, getLabel('common.loadingText')),
                    React__default.createElement(Loader, { className: "upload__loader" })))),
            React__default.createElement(Icon, { width: iconSize, height: iconSize, name: iconName }),
            React__default.createElement("label", { className: "upload__label", htmlFor: inputId }, isUploadSuccess(uploadStatus) ? (React__default.createElement(Text, { variant: "body", className: "upload__file-name" }, uploadStatus.uploadReference.fileName)) : (React__default.createElement("span", { className: "upload__title" }, title))),
            React__default.createElement("input", __assign({}, getInputProps({ disabled: disabled }), { "aria-describedby": ariaDescribedByIDList.join(' '), "data-t": "upload-input", id: inputId })),
            isUploadSuccess(uploadStatus) && (React__default.createElement(IconButton, { onClick: onDeleteClick, "aria-label": getLabel('common.actions.remove') + " " + uploadedFileName, className: "upload__delete" },
                React__default.createElement(Icon, { name: "trash" }))),
            isUploadLoading(uploadStatus) && (React__default.createElement(IconButton, { onClick: onCancelClick, "aria-label": getLabel('common.actions.cancel'), className: "upload__delete" },
                React__default.createElement(Icon, { name: "trash" })))),
        React__default.createElement("div", { id: descriptionId, className: "upload__description" },
            React__default.createElement(Text, { variant: "body-head" }, getFormattedLabel('upload.description', { parseHTML: true })))));
};

var UploadContainer = function (_a) {
    var scope = _a.scope, onStatusChange = _a.onStatusChange, uploadStatus = _a.uploadStatus, referenceId = _a.referenceId, rest = __rest(_a, ["scope", "onStatusChange", "uploadStatus", "referenceId"]);
    var getToken = useRecaptcha().getToken;
    var apiUrl = useApiConfig().apiUrl;
    var configs = useUpload().configs;
    var scopeConfig = configs[scope];
    var controllerRef = React__default.useRef();
    var handleDropSuccess = React__default.useCallback(function (file) { return __awaiter(void 0, void 0, void 0, function () {
        var _a, isRecaptchaTokenRequired, maxFileNameLength, recaptchaToken, _b, uploadToken, isFileNameTooLong, _c, storageId, storageToken, fileRef, error_1;
        var _d, _e;
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!scopeConfig || !statusSuccess(scopeConfig)) {
                        return [2 /*return*/];
                    }
                    onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusLoading());
                    _a = scopeConfig.result, isRecaptchaTokenRequired = _a.isRecaptchaTokenRequired, maxFileNameLength = _a.maxFileNameLength;
                    _f.label = 1;
                case 1:
                    _f.trys.push([1, 7, 8, 9]);
                    controllerRef.current = new AbortController();
                    if (!isRecaptchaTokenRequired) return [3 /*break*/, 3];
                    return [4 /*yield*/, getToken()];
                case 2:
                    _b = _f.sent();
                    return [3 /*break*/, 4];
                case 3:
                    _b = undefined;
                    _f.label = 4;
                case 4:
                    recaptchaToken = _b;
                    return [4 /*yield*/, Upload$1.getUploadToken(apiUrl, {
                            scope: scope,
                            referenceId: referenceId,
                            recaptchaToken: recaptchaToken,
                        }, { signal: (_d = controllerRef.current) === null || _d === void 0 ? void 0 : _d.signal })];
                case 5:
                    uploadToken = (_f.sent()).token;
                    isFileNameTooLong = file.name.length > maxFileNameLength;
                    return [4 /*yield*/, Upload$1.sendFile(apiUrl, __assign({ scope: scope, referenceId: referenceId, uploadedFile: file, uploadToken: uploadToken }, (isFileNameTooLong ? { alias: file.name.slice(0, maxFileNameLength) } : {})), { signal: (_e = controllerRef.current) === null || _e === void 0 ? void 0 : _e.signal })];
                case 6:
                    _c = _f.sent(), storageId = _c.storageId, storageToken = _c.storageToken;
                    fileRef = {
                        storageId: storageId,
                        storageToken: storageToken,
                        fileName: file.name,
                    };
                    // Drop success and upload success
                    onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusSuccess(fileRef));
                    return [3 /*break*/, 9];
                case 7:
                    error_1 = _f.sent();
                    // Drop success but upload failure
                    error_1.name === 'AbortError'
                        ? onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusIdle())
                        : onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusError(error_1));
                    return [3 /*break*/, 9];
                case 8:
                    controllerRef.current = undefined;
                    return [7 /*endfinally*/];
                case 9: return [2 /*return*/];
            }
        });
    }); }, [scopeConfig, onStatusChange, referenceId]);
    var handleDropError = React__default.useCallback(function (fileRejection) {
        onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusError(fileRejection));
    }, [onStatusChange]);
    var handleCancel = React__default.useCallback(function () {
        var _a;
        (_a = controllerRef.current) === null || _a === void 0 ? void 0 : _a.abort();
    }, []);
    var handleDelete = React__default.useCallback(function () {
        onStatusChange === null || onStatusChange === void 0 ? void 0 : onStatusChange(uploadStatusIdle('FILE_REMOVED'));
    }, [onStatusChange]);
    if (!scopeConfig || statusFailed(scopeConfig) || statusWarning(scopeConfig)) {
        // TODO: Do we need to account for a warning status?
        // TODO: Error view to be implemented in MACC-5453
        return React__default.createElement("p", { color: "red" }, "Could not fetch config for this upload.");
    }
    if (statusLoading(scopeConfig) || statusUninit(scopeConfig)) {
        // TODO: Loading view to be implemented in MACC-5453
        return React__default.createElement("p", null, "Fetching config...");
    }
    var _b = scopeConfig.result, maxFileSizeBytes = _b.maxFileSizeBytes, allowedFileTypes = _b.allowedFileTypes;
    return (React__default.createElement(Upload, __assign({}, rest, { uploadStatus: uploadStatus, onFileAccepted: handleDropSuccess, onFileRejected: handleDropError, onDelete: handleDelete, onCancel: handleCancel, maximumFileSizeBytes: maxFileSizeBytes, allowedFileTypes: allowedFileTypes || [] })));
};

export { types as Types, UploadContainer as Upload, UploadProvider, useUpload, useUploadHandler };
//# sourceMappingURL=index.js.map
